import type { Directive } from 'vue';

import { useAuthStore } from '@/entities/auth';

export const vPermission: Directive = {
  mounted(el, binding) {
    const authStore = useAuthStore();
    const permission = binding.value as string | string[];

    const hasPermission = Array.isArray(permission)
      ? authStore.hasAnyPermission(permission)
      : authStore.hasPermission(permission);

    if (!hasPermission) {
      el.style.display = 'none';
    }
  },

  updated(el, binding) {
    const authStore = useAuthStore();
    const permission = binding.value as string | string[];

    const hasPermission = Array.isArray(permission)
      ? authStore.hasAnyPermission(permission)
      : authStore.hasPermission(permission);

    el.style.display = hasPermission ? '' : 'none';
  },
};
